import Util from '../forecast-app/shared/util/util';
import {commitMutation, graphql} from 'react-relay';

const mutation = graphql`
	mutation generateLowHighSuggestionsMutation($input: GenerateLowHighSuggestionsInput!) {
		generateLowHighSuggestions(input: $input) {
			suggestions {
				id
				taskId
				low
				high
				estimate
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	return commitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
